import Icon from '../../../components/AppIcon';
import React from 'react';
import { motion } from 'framer-motion';

const MissionVisionSection = () => {
	const whyChooseUsItems = [
		{
			id: 1,
			title: 'INTEGRITY',
			icon: 'Star',
			description:
				'We uphold the highest ethical standard, ensuring honesty, transparency and confidentiality in every case.',
		},
		{
			id: 2,
			title: 'EXPERIENCE',
			icon: 'Trophy',
			description:
				'With years of expertise across various legal fields, we offer trusted and proven guidance. Our deep knowledge ensures strong representation and the best possible results for our clients.',
		},
		{
			id: 3,
			title: 'INNOVATION',
			icon: 'Zap',
			description:
				'We embrace modern legal solutions to tackle complex challenges efficiently. By leveraging technology and creative thinking, we provide smarter, faster legal support.',
		},
		{
			id: 4,
			title: 'EXCELLENCE',
			icon: 'Target',
			description:
				'We strive for the best outcomes through meticulous legal strategies and dedicated advocacy. Our team is committed to delivering top-tier legal services with precision and skill.',
		},
	];

	return (
		<section className='py-20 bg-white'>
			<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
				<div className='grid lg:grid-cols-2 gap-16'>
					{/* Left Column - Mission & Vision */}
					<motion.div
						initial={{ opacity: 0, x: -50 }}
						whileInView={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.8 }}
						viewport={{ once: true }}
						className='space-y-12'
					>
						<h2 className='font-source font-bold text-4xl lg:text-5xl text-gray-800 uppercase tracking-wide'>
							Mission & Vision
						</h2>

						{/* Our Mission */}
						<div className='flex items-start space-x-6'>
							<div className='w-16 h-16 bg-[#800020] rounded-lg flex items-center justify-center flex-shrink-0 shadow-lg'>
								<span className='font-playfair font-bold text-2xl text-white'>A</span>
							</div>
							<div>
								<h3 className='font-source font-bold text-2xl text-gray-800 mb-4'>Our Mission</h3>
								<p className='font-source text-lg text-gray-700 leading-relaxed'>
									Our mission is to provide exceptional legal services with unwavering dedication,
									integrity and client satisfaction. We are committed to providing innovative and
									client-focused legal services that set a new benchmark in efficiency and
									professionalism. We stay ahead of industry changes, offering personalized,
									forward-thinking solutions that anticipate and meet the evolving needs of our
									clients
								</p>
							</div>
						</div>

						{/* Our Vision */}
						<div className='flex items-start space-x-6'>
							<div className='w-16 h-16 bg-[#DB954E] rounded-lg flex items-center justify-center flex-shrink-0 shadow-lg'>
								<Icon name='TrendingUp' size={32} color='white' />
							</div>
							<div>
								<h3 className='font-source font-bold text-2xl text-gray-800 mb-4'>Our Vision</h3>
								<p className='font-source text-lg text-gray-700 leading-relaxed'>
									To be a leading corporate and commercial law firm, recognized for delivering
									exceptional legal services that shape the future of business success and inspire
									unwavering trust across industries through innovation, integrity, experience and
									excellent service delivery that meets the needs of our clients.
								</p>
							</div>
						</div>
					</motion.div>

					{/* Right Column - Why Choose Us */}
					<motion.div
						initial={{ opacity: 0, x: 50 }}
						whileInView={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.8, delay: 0.2 }}
						viewport={{ once: true }}
						className='space-y-12'
					>
						<h2 className='font-source font-bold text-4xl lg:text-5xl text-gray-800 uppercase tracking-wide'>
							Why Choose Us?
						</h2>

						<div className='grid grid-cols-1 sm:grid-cols-2 gap-8'>
							{whyChooseUsItems.map((item, index) => (
								<motion.div
									key={item.id}
									initial={{ opacity: 0, y: 30 }}
									whileInView={{ opacity: 1, y: 0 }}
									transition={{ duration: 0.6, delay: index * 0.1 }}
									viewport={{ once: true }}
									className='space-y-4'
								>
									<div className='flex items-center space-x-4'>
										<div className='w-12 h-12 bg-[#DB954E] rounded-lg flex items-center justify-center flex-shrink-0 shadow-md'>
											<Icon name={item.icon} size={24} color='white' />
										</div>
										<h3 className='font-source font-bold text-xl text-gray-800 uppercase tracking-wide'>
											{item.title}
										</h3>
									</div>
									<p className='font-source text-base text-gray-700 leading-relaxed'>
										{item.description}
									</p>
								</motion.div>
							))}
						</div>
					</motion.div>
				</div>
			</div>
		</section>
	);
};

export default MissionVisionSection;
